import { createPinia } from "pinia";
import { useGlobalStore } from "./loginForm";

import { createApp } from "vue";
import piniaPersist from "pinia-plugin-persist";

const pinia = createPinia();
pinia.use(piniaPersist);
const app = createApp({
  template: `
      <div id="store" style="position: absolute"></div>`,
});
app.use(pinia);
app.mount("#store");

const store = useGlobalStore();

export const useShowLoginForm = {
  get: () => store.showForm,
  set: (value: any) => store.showLoginForm(value),
};


export const loginFormSuscribe = store.$subscribe;
